import './SearchBox.scss';
import SearchIcon from '../../../images/search-icon.png';

export const SearchBox = ({ placeholder, value, onChange }) => {
  return (
    <div className="search-box">
      <img src={SearchIcon} alt="SearchIcon" />
      <input type="text" placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  );
};
